import { render, staticRenderFns } from "./BoxReceive.vue?vue&type=template&id=5c3e4d44&"
import script from "./BoxReceive.vue?vue&type=script&lang=js&"
export * from "./BoxReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports